import {orderDepthDesktop, OrderDepthDesktop, orderDepthMobile, OrderDepthMobile} from "./grid/OrderDepthComponent";
import {orderDepthV2, OrderDepthV2} from "./grid-v2/OrderDepthComponentV2";

export default function() {
    return angular.module("tfApp.depth.components", [])
                  .component(OrderDepthDesktop, orderDepthDesktop())
                  .component(OrderDepthMobile, orderDepthMobile())
                  .component(OrderDepthV2, orderDepthV2())
                  .name;
}
